module.exports = __webpack_public_path__ + "img/media-12.d1ea81c9.png";